const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.FOOD_PRODUCTION_STAGE)

export const apiFoodProductionStage = {
	fetchDietFoodProductionStages: async (): Promise<IDietProductionStepItemModel[]> => {
		const { data } = await apiCommon<IDietProductionStepItem[]>(`${groupPrefix}`, { method: 'GET' })

		return data.map(item => DietProductionStepItem(item))
	},
}
